
import { mapActions, mapState, mapGetters } from "vuex";
import ResponsiveDialog from "./responsive-dialog.vue";
export default {
  components: { ResponsiveDialog },
  props: {
    dialog: false,
    persistent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      restaurantsLoading: false
    };
  },
  beforeMount() {
    this.fetchAvailableRestaurants();
  },
  computed: {
    ...mapState("order", ["cart", "restaurantsList"]),
    ...mapGetters("order", ["getRestaurantsListDistance", "isHomeDelivery"])
  },
  methods: {
    ...mapActions("order", [
      "getAvailableRestaurants",
      "getInfo",
      "getRestaurantsList"
    ]),
    async fetchAvailableRestaurants() {
      this.restaurantsLoading = true;
      try {
        if (!this.restaurantsList?.length) {
          await this.getRestaurantsList();
        }
        if (this.isHomeDelivery) {
          await this.getAvailableRestaurants({
            latitude: this.cart.delivery_address?.lat,
            longitude: this.cart.delivery_address?.lng
          });
        }
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }
      this.restaurantsLoading = false;
    },
    async handleLocationSelection(location) {
      this.$ls.set("selected-restaurant", location.restaurant_id);
      try {
        await this.getInfo();
        this.$emit("close-dialog");
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }
    }
  }
};
